
import { computed, defineComponent, PropType, shallowRef } from 'vue'
import {
  DashboardCard,
  Loader,
  FiltersChip,
  determinePageSize,
} from '@bd/components'
import { agentApi, AgentOfferRowDto } from '@bd/api'
import { InfiniteScroll } from '@bd/components'
import { useAppStore } from '@bd/agent/store'
import { ComputedFilter } from '@bd/store-modules/types'
import { CityWithProvinceDto } from '@bd/api'
import { showDraftsOffers } from '@bd/agent/config/common.json'
import EmptyState from '@bd/components/EmptyState/EmptyState.vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'DashboardOfferList',
  components: {
    DashboardCard,
    Loader,
    FiltersChip,
    EmptyState,
    InfiniteScroll: InfiniteScroll.InfiniteScroll,
  },
  emits: ['clear-filter'],
  props: {
    activeFilters: {
      type: Array as PropType<ComputedFilter[]>,
      required: true,
    },
    citiesAndProvinces: {
      type: Array as PropType<CityWithProvinceDto[]>,
      required: true,
    },
  },
  setup() {
    const store = useAppStore()
    const isLoading = shallowRef(false)
    const i18n = useI18n()

    const districts = computed(() => store.state.offers?.districts)

    // not reactive on purpose. InfiniteScroll component has internal logic that
    // adjusts number of pages fetched in parallel depending on container size.
    const pageSize = determinePageSize()

    const getOffersPage = computed<InfiniteScroll.GetPageFn>(() => {
      const filters = store.state.offers?.searchedFilters
      return async (page) => {
        const { data } = await agentApi.offers({
          ...filters,
          ...page,
          showDrafts: showDraftsOffers,
        })
        return data
      }
    })

    const getOfferId = (offer: AgentOfferRowDto) => {
      return offer.id
    }

    return {
      t: i18n.t,
      pageSize,
      getOffersPage,
      getOfferId,
      isLoading,
      districts,
    }
  },
})
